import { ApolloProvider } from '@apollo/client';
import { useAuthenticationDetails } from 'hooks/useAuthenticationDetails';
import { useConfig } from 'context/config';
import { getApolloClient } from 'app/apollo/apolloClient';
import type { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

type ApolloWrapperProps = {
  children: ReactNode;
};

export const ApolloWrapper = (props: ApolloWrapperProps) => {
  const { logout } = useAuth0();
  const { VITE_GRAPHQL_ENDPOINT } = useConfig();
  const { accessToken } = useAuthenticationDetails();
  const apolloClient = getApolloClient(accessToken, VITE_GRAPHQL_ENDPOINT, logout);

  return <ApolloProvider client={apolloClient}>{props.children}</ApolloProvider>;
};
